import { useQuery } from '@tanstack/react-query';
import { ApiModel, CartBuyerModel, CartBuyerModelConverter } from '@steelbuy/ts-shared';
import axios from '../../axios';

type SelfApiModel = {
    offers: {
        sellerCount: number;
        buyerCount: number;
    };
    cartDetails?: CartBuyerModel;
};

const modelConverter = new CartBuyerModelConverter();

const getSelfUpdates = async () => {
    const { data } = await axios.get<SelfApiModel>(`/api/universal/users/self-updates`);
    const cartModel = modelConverter.toViewModel(data.cartDetails as unknown as ApiModel<CartBuyerModel>);
    return { ...data, cartDetails: cartModel };
};

export const useSelfUpdates = ({ queryOptions } = { queryOptions: { enabled: false } }) =>
    useQuery({
        queryKey: ['self-updates'],
        queryFn: () => getSelfUpdates(),
        ...queryOptions,
    });
